import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SoftwareWhiteIcon = ({ id })=>/*#__PURE__*/ _jsxs("svg", {
        width: "45",
        height: "33",
        viewBox: "0 0 45 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                id: "Group 1261160633",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        id: "Vector",
                        d: "M5.12256 25.1277H21.1478C26.7948 25.1277 31.3699 20.6479 31.3699 15.1185C31.3699 9.5891 26.7948 5.10938 21.1478 5.10938",
                        stroke: "url(#paint0_linear_3732_2139)",
                        "stroke-width": "9.10995",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        id: "Vector_2",
                        d: "M21.3832 9.66435C23.8989 9.66435 25.9382 7.62502 25.9382 5.10938C25.9382 2.59373 23.8989 0.554398 21.3832 0.554398V9.66435ZM34.7819 29.6826H39.3369V20.5727H34.7819V29.6826ZM21.3832 0.554398C13.3114 0.554398 6.60616 6.98352 6.60616 15.1185H15.7161C15.7161 12.1947 18.1609 9.66435 21.3832 9.66435V0.554398ZM6.60616 15.1185C6.60616 23.2535 13.3114 29.6826 21.3832 29.6826V20.5727C18.1609 20.5727 15.7161 18.0424 15.7161 15.1185H6.60616ZM21.3832 29.6826H34.7819V20.5727H21.3832V29.6826Z",
                        fill: "url(#paint1_linear_3732_2139)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        id: "Polygon 1",
                        d: "M43.345 23.9987C43.9711 24.6213 43.9711 25.6344 43.345 26.2569L40.3813 29.2043C39.3768 30.2032 37.666 29.4917 37.666 28.0752L37.666 22.1805C37.666 20.7639 39.3768 20.0525 40.3813 21.0513L43.345 23.9987Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_3732_2139",
                        x1: "24.0076",
                        y1: "7.83206",
                        x2: "24.0076",
                        y2: "20.0842",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                "stop-color": "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.905957",
                                "stop-color": "white",
                                "stop-opacity": "0.6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_3732_2139",
                        x1: "35.0217",
                        y1: "27.0324",
                        x2: "24.4352",
                        y2: "12.4881",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.193864",
                                "stop-color": "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                "stop-color": "white"
                            })
                        ]
                    })
                ]
            })
        ]
    });
